export default {
  name: "Pushes",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPushes: false,
      timeoutId: null,
      audio: null,
    };
  },
  created() {
    this.audio = new Audio('/notification.mp3');
    // const viewedPushes = localStorage.getItem('viewedPushes');
    // if (viewedPushes) return
    this.timeoutId = setTimeout(() => {
      this.showPushes = true;
      // localStorage.setItem('viewedPushes', "1")
      this.playPushSound();
    }, 5000);
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
  methods: {
    playPushSound() {
      this.audio.play().catch(error => {
        console.error("Audio playback error:", error);
      });
    }
  }
};
